import { render } from "./FormDireccion.vue?vue&type=template&id=daf71130"
import script from "./FormDireccion.vue?vue&type=script&lang=js"
export * from "./FormDireccion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__